import type { AssessmentSubject } from './subject.js';
import type { PredicateName } from './types.js';

/**
 * Implementacao dos predicados. O NOME vai na especificacao (dado puro,
 * serializavel, auditavel); a implementacao vive aqui. Nada de `eval`, nada de
 * linguagem de expressao dentro do JSON.
 *
 * Contrato: retorna `null` quando esta tudo certo, ou um detalhe curto que sera
 * anexado a mensagem da regra.
 */
export type Predicate = (s: AssessmentSubject) => string | null;

const obs = (s: AssessmentSubject, trait: string) =>
  s.sessions
    .filter((x) => x.method === 'campo')
    .flatMap((x) => x.observations)
    .filter((o) => o.trait === trait);

export const predicates: Record<PredicateName, Predicate> = {
  prenhezExigeMeses: (s) =>
    s.management.femaleStatus === 'prenhe' && s.management.gestationMonths == null
      ? 'femea prenhe sem meses de gestacao'
      : null,

  claudicacaoBloqueiaDinamica: (s) => {
    const grade = s.management.lamenessAaep;
    if (!s.hasGaitData) return null;
    if (grade != null && grade >= 1) return `claudicacao grau AAEP ${grade}`;
    if (s.management.fitness === 'claudicacao' || s.management.fitness === 'lesao') {
      return `animal registrado como ${s.management.fitness}`;
    }
    return null;
  },

  chegadaRecenteForcaNivel1: (s) =>
    s.management.arrivedFarmGt30d === false && s.level > 1
      ? `chegou ha menos de 30 dias, mas a ficha esta no Nivel ${s.level}`
      : null,

  ferrageamentoNaoPodeSerFuturo: (s) => {
    const shoeing = s.management.lastShoeingDate;
    if (!shoeing) return null;
    return shoeing > s.assessedAt.slice(0, 10) ? `ferrageamento em ${shoeing}` : null;
  },

  peAbdExigeHora: (s) => {
    const medidas = obs(s, 'PE_ABD').filter((o) => o.value != null);
    return medidas.some((o) => o.observedAt == null) ? 'PE_ABD sem hora registrada' : null;
  },

  duplaMedicaoExigeSegundoAvaliador: (s) => {
    if (!s.sampledForDoubleMeasure) return null;
    const campo = s.sessions.filter((x) => x.method === 'campo');
    const avaliadores = new Set(campo.map((x) => x.evaluatorId));
    if (campo.length < 2) return 'existe apenas uma sessao de medicao';
    if (avaliadores.size < 2) return 'as duas sessoes tem o mesmo avaliador';
    return null;
  },

  pesoEEccObrigatorios: (s) => {
    const m = s.management;
    const faltando = [
      m.weightKg == null && 'peso',
      m.weightMethod == null && 'metodo de pesagem',
      m.bcsHenneke == null && 'ECC',
    ].filter(Boolean);
    return faltando.length ? `falta ${faltando.join(', ')}` : null;
  },
};
